module.exports = {
      id: "ic-other-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-other-usage",
      toString: function () {
        return this.url;
      }
    }